import React from 'react';
import { FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { VoIPDevice } from '../utils/voipTypes';

interface VoIPDeviceCardsProps {
  devices: VoIPDevice[];
  onDeviceClick: (device: VoIPDevice) => void;
}

const VoIPDeviceCards: React.FC<VoIPDeviceCardsProps> = ({ devices, onDeviceClick }) => {
  const getStatusClass = (device: VoIPDevice): string => {
    if (device.status === 'offline') return 'status-offline';
    if (device.status === 'warning') return 'status-warning';
    return 'status-online';
  };

  const getStatusLabel = (device: VoIPDevice): string => {
    if (device.status === 'offline') return 'Offline';
    if (device.status === 'warning') return 'Warning';
    return 'Online';
  };

  if (devices.length === 0) {
    return (
      <div className="no-data">
        <div className="no-data-icon"><FaPhone /></div>
        <h3>No VoIP devices found</h3>
      </div>
    );
  }

  return (
    <div className="voip-cards-container">
      {devices.map((device) => {
        return (
          <div
            key={device.id}
            className="voip-device-card"
            onClick={() => onDeviceClick(device)}
          >
            <div className="voip-card-header">
              <div className="device-info">
                <h3>{device.name}</h3>
                <div className="device-location">
                  <FaMapMarkerAlt />
                  {device.station}
                </div>
              </div>
              <div className="card-badges">
                {device.vendor && device.vendor !== 'UNKNOWN' && (
                  <span className={`vendor-badge ${device.vendor.toLowerCase()}`}>
                    {device.vendor}
                  </span>
                )}
                <span className={`device-status-badge ${getStatusClass(device)}`}>
                  {getStatusLabel(device)}
                </span>
              </div>
            </div>

            <div className="voip-card-body">
              <div className="info-row">
                <div className="info-item">
                  <span className="info-label">IP Address</span>
                  <span className="info-value mono">{device.ipAddress}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Vendor</span>
                  <span className="info-value">{device.vendor || '-'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-item">
                  <span className="info-label">Registration</span>
                  <span className={`info-value ${device.registrationStatus === 'registered' ? 'success' : 'error'}`}>
                    {device.registrationStatus}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Make</span>
                  <span className="info-value">{device.assetDetails?.make || '-'}</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VoIPDeviceCards;
